import { BodySmallTypography, ButtonLink } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const EditButton = styled(ButtonLink)`
  ${BodySmallTypography}
  padding-top: 16px;
`
